
import Button from '../../../components/base/Button';

export default function CallToActionSection() {
  return (
    <section className="py-20 bg-dark-800">
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Have Questions? <span className="text-red-500">Let's Talk</span>
          </h2>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            Every mortgage situation is unique, and I believe the best solutions come from understanding 
            your specific needs and goals. Book a consultation today and let's explore your options together.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-dark-900 border border-dark-700 rounded-xl p-6 shadow-md">
              <i className="ri-phone-line text-3xl text-red-500 mb-4"></i>
              <h3 className="font-bold text-lg mb-2 text-white">Free Consultation</h3>
              <p className="text-gray-300 text-sm">
                No obligation, no pressure. Just honest advice about your mortgage options.
              </p>
            </div>
            
            <div className="bg-dark-900 border border-dark-700 rounded-xl p-6 shadow-md">
              <i className="ri-time-line text-3xl text-red-500 mb-4"></i>
              <h3 className="font-bold text-lg mb-2 text-white">Quick Response</h3>
              <p className="text-gray-300 text-sm">
                I understand timing matters. Expect prompt responses to all your inquiries.
              </p>
            </div>
            
            <div className="bg-dark-900 border border-dark-700 rounded-xl p-6 shadow-md">
              <i className="ri-shield-check-line text-3xl text-red-500 mb-4"></i>
              <h3 className="font-bold text-lg mb-2 text-white">Trusted Expertise</h3>
              <p className="text-gray-300 text-sm">
                25+ years of experience and Level 2 certification working for you.
              </p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://calendly.com/tjcmonteiro/free-mortgage-consultation-with-tony-monteiro"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="primary" size="lg" className="text-lg">
                <i className="ri-calendar-check-line mr-2"></i>
                Book a Call Today
              </Button>
            </a>
            <a href="tel:5196583026">
              <Button variant="secondary" size="lg" className="text-lg">
                <i className="ri-phone-line mr-2"></i>
                (519) 658-3026
              </Button>
            </a>
          </div>
          
          {/* Trust reinforcement */}
          <div className="mt-12 pt-8 border-t border-dark-700">
            <div className="flex justify-center items-center space-x-8 text-gray-400">
              <div className="text-center">
                <div className="font-bold text-red-500 text-lg">Lic# 13121</div>
                <div className="text-xs">Licensed Agent</div>
              </div>
              <div className="text-center">
                <div className="font-bold text-red-500 text-lg">Level 2</div>
                <div className="text-xs">Certified</div>
              </div>
              <div className="text-center">
                <div className="font-bold text-red-500 text-lg">25+ Years</div>
                <div className="text-xs">Experience</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
